<?xml version="1.0" encoding="UTF-8"?>
<svg width="14px" height="15px" viewBox="0 0 14 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <rect id="Rectangle" fill="#F96892" x="0" y="0" width="14" height="15" rx="2"></rect>
        <rect id="Rectangle" fill="#FFFFFF" x="0" y="5.5" width="14" height="4" rx="2"></rect>
    </g>
</svg>